export default __webpack_public_path__ + "static/media/spaceShipA2.2bd42b27.webp";